import { map, filter } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../store';
// utils
import axios from '../../utils/axios';
import { RoutesType } from '../../@types/routesType';
import URLConstants from 'constants/urlConstants';

type RoutesState = {
    isLoading: boolean;
    error: boolean;
    routes: RoutesType[];
}

const initialState: RoutesState = {
    isLoading: false,
    error: false,
    routes: [],
}

const slice = createSlice({
    name: 'routes',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },

        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        // GET ROUTES
        getRoutesSuccess(state, action) {
            state.isLoading = false;
            state.routes = action.payload;
        },
    }
});

// Reducer
export default slice.reducer;


export function getRoutesList() {
    return async () => {
      dispatch(slice.actions.startLoading());
      try {
        const response = await axios.get(URLConstants.ROUTES_BASE_URL);
        dispatch(slice.actions.getRoutesSuccess(response.data.data));
      } catch (error) {
        dispatch(slice.actions.hasError(error));
      }
    };
  }